// Copyright (c) Microsoft. All rights reserved.
import { InformationCircleIcon } from '@heroicons/react/24/outline';
import React, { useState } from 'react';
import { IAppDropdownConfigValue } from '../../../../libs/services/AppConfigService';
import { getScopeIcon } from '../../../utils/IconUtils';
import { ModalDialog } from '../ChatWindow/Shared/ModalDialog';

interface IScopeInfoDialogProps {
    scopeOptions: IAppDropdownConfigValue[];
}

export const ScopeInfoDialog: React.FC<IScopeInfoDialogProps> = ({ scopeOptions }) => {
    const [open, setOpen] = useState(false);

    const getDialogContent = () => {
        return scopeOptions.map((option) => {
            if (!option.title) {
                return null;
            }

            return (
                <div key={option.name} className="mt-3 mb-7 flex flex-row items-top">
                    <div className="flex items-center">
                        <div className="w-7 h-7">
                            <img
                                src={getScopeIcon(option.name)}
                                alt="Bot Avatar"
                                className="w-full h-full object-cover"
                            />
                        </div>
                    </div>
                    <div className="flex flex-col ml-3">
                        <h3 className="font-semibold mx-0">{option.title}</h3>
                        <p className="font-normal">{option.description}</p>
                    </div>
                </div>
            );
        });
    };

    return (
        <>
            <div className="tooltip tooltip-bottom hidden sm:inline" data-tip="Show source guidance">
                <button onClick={() => setOpen(true)} className="inline-flex align-middle p-0 mb-[2px] mr-1 my-auto">
                    <InformationCircleIcon className="w-4 h-4 hover:text-primary transition-all duration-300" />
                </button>
            </div>
            <ModalDialog
                title={`Source guidance for ${import.meta.env.VITE_APP_NAME}`}
                open={open}
                onClose={() => setOpen(false)}>
                <div>{getDialogContent()}</div>
            </ModalDialog>
        </>
    );
};
